const VI = 'vi-VN';

export function formatValue(value, format, options = {}) {
    if (value == null) return '—';

    switch (format) {
        case 'number':
            return Number(value).toLocaleString(VI);

        case 'currency':
            return Number(value).toLocaleString(VI) + (options.suffix || 'đ');

        case 'percent': {
            const num = Number(value);
            const sign = num > 0 ? '+' : '';
            return sign + num.toFixed(options.decimals ?? 2) + '%';
        }

        case 'compact': {
            const num = Number(value);
            const abs = Math.abs(num);
            if (abs >= 1e12) return (num / 1e12).toFixed(1) + 'T';
            if (abs >= 1e9) return (num / 1e9).toFixed(1) + 'B';
            if (abs >= 1e6) return (num / 1e6).toFixed(1) + 'M';
            if (abs >= 1e3) return (num / 1e3).toFixed(1) + 'K';
            return num.toLocaleString(VI);
        }

        case 'date': {
            const d = new Date(value);
            if (isNaN(d)) return String(value);
            return d.toLocaleDateString(VI);
        }

        default:
            return String(value);
    }
}

export function colorByValue(value) {
    const num = Number(value);
    if (num > 0) return 'text-green-500';
    if (num < 0) return 'text-red-500';
    return 'text-gray-500 dark:text-gray-400';
}

export function statusToColor(status) {
    const map = {
        success: 'text-green-500',
        danger: 'text-red-500',
        warning: 'text-amber-500',
        info: 'text-blue-500',
        neutral: 'text-gray-500 dark:text-gray-400',
    };
    return map[status] || map.neutral;
}

export function statusToBg(status) {
    const map = {
        success: 'bg-green-500/10 text-green-500',
        danger: 'bg-red-500/10 text-red-500',
        warning: 'bg-amber-500/10 text-amber-500',
        info: 'bg-blue-500/10 text-blue-500',
        neutral: 'bg-gray-500/10 text-gray-500',
    };
    return map[status] || map.neutral;
}
